import {FC} from 'react';
import ColorsType from '../../types/ColorsType';
import UIColorCard from '../UICommon/UIColorCard';
import UIErrorIndicator from '../UICommon/UIErrorIndicator';

type ChooseColorsAllColorsProps = {
  colors: ColorsType[];
  refetchFavorites: Function;
  setIsLoadingFavorites: Function;
  setChosenColors: Function;
  chosenColors: any;
}

const ChooseColorsAllColors: FC<ChooseColorsAllColorsProps> = ({
  colors,
  refetchFavorites,
  setIsLoadingFavorites,
  setChosenColors,
  chosenColors,
}) => {
  if (Object.keys(colors).length === 0) {
    return <UIErrorIndicator/>;
  }
  return (
    <div className='flex flex-wrap justify-between'>
      {colors?.map((el: ColorsType) => (
        <UIColorCard
          key={el.id}
          id={el.id}
          name={el.name}
          tone={el.tone}
          brand={el.brand}
          img={el.image}
          refetchFavorites={refetchFavorites}
          setIsLoadingFavorites={setIsLoadingFavorites}
          setChosenColors={setChosenColors}
          chosenColors={chosenColors}
          style='mb-8'
        />
      ))}
    </div>
  );
};

export default ChooseColorsAllColors;
